<template>
  <!-- Blog-section start -->
  <section class="blog-eight-section">
    <div class="container">
      <div class="section-heading heading-eight">
        <div class="row align-items-center">
          <div
            class="col-md-12 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Recent News &amp; Articles</h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
            </p>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-lg-4 col-md-6 col-sm-12 d-flex">
            <div
              class="blog-eight grid-blog-eight flex-fill aos aos-init aos-animate"
              data-aos="fade-up"
            >
              <div class="blog-image-eight">
                <router-link to="blog-details">
                  <img
                    src="@/assets/img/blog/news-article-1.jpg"
                    class="img-fluid"
                    alt="Post Image"
                  />
                </router-link>
              </div>
              <div class="blog-content-eight">
                <p class="blog-category-eight">
                  <a href="javascript:void(0);"><span>Popular Jobs</span></a>
                  <a href="javascript:void(0);"><span>UX Designer</span></a>
                  <a href="javascript:void(0);"><span>Paris</span></a>
                </p>
                <h3 class="blog-title">
                  <router-link to="blog-details"
                    >Lorem Ipsum is simply dummy text of the printing industry.
                  </router-link>
                </h3>
                <p class="blog-description-eight">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                  lectus elementum lectus eu nisl, purus...
                </p>
                <ul class="entry-meta meta-item-eight">
                  <li>
                    <div class="post-author-eight">
                      <div class="post-author-img-eight">
                        <img
                          src="@/assets/img/profiles/avatar-05.jpg"
                          alt="Post Author"
                        />
                      </div>
                      <a href="javascript:void(0);" class="mb-0">
                        <span> John </span></a
                      >
                    </div>
                  </li>
                  <li>
                    <div class="post-author-btn">
                      <router-link to="blog-details">
                        Read More <i class="fa-solid fa-arrow-right"></i
                      ></router-link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 d-flex">
            <div
              class="blog-eight grid-blog-eight flex-fill aos aos-init aos-animate"
              data-aos="fade-up"
            >
              <div class="blog-image-eight">
                <router-link to="blog-details"
                  ><img
                    class="img-fluid"
                    src="@/assets/img/blog/news-article-2.jpg"
                    alt="Post Image"
                /></router-link>
              </div>
              <div class="blog-content-eight">
                <p class="blog-category-eight">
                  <a href="javascript:void(0);"><span>Popular Jobs</span></a>
                  <a href="javascript:void(0);"><span>Web Designer</span></a>
                  <a href="javascript:void(0);"><span>London</span></a>
                </p>
                <h3 class="blog-title">
                  <router-link to="blog-details"
                    >Lorem Ipsum is simply dummy text of the printing industry.
                  </router-link>
                </h3>
                <p class="blog-description-eight">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                  lectus elementum lectus eu nisl, purus...
                </p>
                <ul class="entry-meta meta-item-eight">
                  <li>
                    <div class="post-author-eight">
                      <div class="post-author-img-eight">
                        <img
                          src="@/assets/img/profiles/avatar-05.jpg"
                          alt="Post Author"
                        />
                      </div>
                      <a href="javascript:void(0);" class="mb-0">
                        <span> Smith </span></a
                      >
                    </div>
                  </li>
                  <li>
                    <div class="post-author-btn">
                      <router-link to="blog-details">
                        Read More <i class="fa-solid fa-arrow-right"></i
                      ></router-link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 d-flex">
            <div
              class="blog-eight grid-blog-eight flex-fill aos aos-init aos-animate"
              data-aos="fade-up"
            >
              <div class="blog-image-eight">
                <router-link to="blog-details"
                  ><img
                    class="img-fluid"
                    src="@/assets/img/blog/news-article-3.jpg"
                    alt="Post Image"
                  />
                </router-link>
              </div>
              <div class="blog-content-eight">
                <p class="blog-category-eight">
                  <a href="javascript:void(0);"><span>Popular Jobs</span></a>
                  <a href="javascript:void(0);"><span>UI Designer</span></a>
                  <a href="javascript:void(0);"><span>New York</span></a>
                </p>
                <h3 class="blog-title">
                  <router-link to="blog-details"
                    >Lorem Ipsum is simply dummy text of the printing industry.
                  </router-link>
                </h3>
                <p class="blog-description-eight">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
                  lectus elementum lectus eu nisl, purus...
                </p>
                <ul class="entry-meta meta-item-eight">
                  <li>
                    <div class="post-author-eight">
                      <div class="post-author-img-eight">
                        <img
                          src="@/assets/img/profiles/avatar-05.jpg"
                          alt="Post Author"
                        />
                      </div>
                      <a href="javascript:void(0);" class="mb-0">
                        <span> David </span></a
                      >
                    </div>
                  </li>
                  <li>
                    <div class="post-author-btn">
                      <router-link to="blog-details">
                        Read More
                        <i class="fa-solid fa-arrow-right"></i>
                      </router-link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="align-items-center justify-content-center d-flex aos"
        data-aos="fade-up"
      >
        <router-link to="blog-details" class="category-btn"
          >View All Category</router-link
        >
      </div>
    </div>
  </section>
  <!-- Blog-section end -->
</template>
